import { useState } from 'react'
import TextInput from 'components/TextInput'
import { useTranslation } from 'react-i18next'
import { formateTime } from './helper'

export type Meridiem = 'AM' | 'PM'
export type onTimeChangeParam = TimeObj & { inputValue: string }

type TimeObj = {
  hours: number
  minutes: number
  meridiem: Meridiem
}

type Props = {
  timeValue?: string
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void
  onChangeSearchTime: (obj: onTimeChangeParam) => void
  timeInputErrorRef: React.RefObject<{ value: boolean }>
  timeInputRef?: React.RefObject<HTMLInputElement>
}

export default function TimeInput({
  timeValue = '',
  onChangeSearchTime,
  onClick,
  timeInputRef,
  timeInputErrorRef,
}: Props) {
  const [input, setInput] = useState(timeValue)
  const [error, setError] = useState('')
  const { t } = useTranslation()

  const handleError = (isError = false) => {
    !isError ? setError('') : setError(t('invalid_time'))

    if (timeInputErrorRef.current) {
      timeInputErrorRef.current.value = isError
    }
  }

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation()
    const inputValue = e.target.value
    const { numHours, numMinutes, meridiem } = formateTime(inputValue)
    setInput(inputValue)

    if (isNaN(numHours) || numHours > 24) {
      handleError(true)
      return
    }

    if (isNaN(numMinutes) || numMinutes > 59) {
      handleError(true)
      return
    }

    if (meridiem && !['AM', 'PM'].includes(meridiem.trim().toUpperCase())) {
      handleError(true)
      return
    }

    handleError(false)

    onChangeSearchTime({
      hours: numHours,
      minutes: numMinutes,
      meridiem: (meridiem || 'AM').trim() as Meridiem,
      inputValue: inputValue.trim(),
    })
  }

  const handleOnClick = (e: React.MouseEvent<HTMLInputElement>) => {
    e.stopPropagation()
    onClick?.(e)
  }

  return (
    <TextInput
      ref={timeInputRef}
      width="auto"
      isError={false}
      error={error}
      showError={!!error}
      errorVariant="error"
      variant="simple"
      data-testid="time-input"
      onClick={handleOnClick}
      placeholder="time_lbl"
      type="text"
      padding="0 11px !important"
      value={input}
      onChange={handleOnChange}
    />
  )
}
